import {Amphora,BookOpen,Bot,Brain,BrainCog,Car,Clock3,CloudLightning,Cpu,Drama,Dumbbell,Eye,Film,Fingerprint,Flag,Gamepad2,Globe,Headphones,Heart,HeartPulse,KeyRound,Landmark,Lectern,Lightbulb,Monitor,Music2,PiggyBank,Plane,Rocket,ShieldHalf,Shirt,Skull,Smartphone,Smile,Sparkles,Star,Swords,Trophy,Utensils,Wallet,createLucideIcon} from 'lucide-react';
import type {LucideIcon} from 'lucide-react';
import type {Category} from '../stories';

export const CricketIcon=createLucideIcon('CricketBat',[
 ['path',{d:'m14 3 3 3-4 4-3-3z',key:'handle'}],
 ['path',{d:'m10 7 3 3-6 9a2 2 0 0 1-3 0l-1-1a2 2 0 0 1 0-3z',key:'bat'}],
 ['circle',{cx:'18',cy:'18',r:'3',key:'ball'}],
 ['path',{d:'m17 16 1 1-1 1 1 1',key:'seam'}],
]);
export const BaseballIcon=createLucideIcon('BaseballBall',[
 ['circle',{cx:'12',cy:'12',r:'9',key:'ball'}],
 ['path',{d:'M7 4a13 13 0 0 1 0 16M17 4a13 13 0 0 0 0 16',key:'seams'}],
 ['path',{d:'m8 7 3 1m-2 3h3m-3 4 2-1m5-7-3 1m2 3h-3m3 4-2-1',key:'stitches'}],
]);
// One distinct drawing per category; shared by every Home category entry/shelf.
export const categoryIcons:Record<Category,LucideIcon>={
 Crime:Fingerprint,Robbery:Landmark,Mystery:Sparkles,War:Swords,History:Clock3,
 Spy:KeyRound,Space:Rocket,Movies:Film,Music:Music2,AI:Cpu,'Serial Killer':Skull,
 Politics:Lectern,'Civil war':ShieldHalf,Discovery:Lightbulb,Robots:Bot,Internet:Globe,
 Scam:Drama,Crypto:Wallet,Apps:Smartphone,Psychology:BrainCog,Technology:Monitor,
 Gadgets:Headphones,Food:Utensils,Fashion:Shirt,Health:HeartPulse,Dating:Heart,
 'Personal Finance':PiggyBank,Celebrities:Star,Travel:Plane,Sports:Trophy,
 Cricket:CricketIcon,Football:Flag,Baseball:BaseballIcon,'Mental Health':Brain,
 Fitness:Dumbbell,Gaming:Gamepad2,Books:BookOpen,Comedy:Smile,Automobiles:Car,
 Culture:Amphora,Strange:Eye,Disasters:CloudLightning,
};
